// extracted by mini-css-extract-plugin
module.exports = {"normal":"ResourceUtilizationReportTable_normal__fzZXo","high":"ResourceUtilizationReportTable_high__X1QoW"};